import { REDUCER_KEY_EXPERT_INQUIRY, } from "./expertInquiry.reducer";
export var partnerships = function (state) {
    return state[REDUCER_KEY_EXPERT_INQUIRY].partnerships;
};
